import { useMutation, useQueryClient } from "react-query";
import { useSetRecoilState } from "recoil";
import { error_message, success_message } from '../../global_state'
import { edit_timesheet } from "../../services/timesheet";


const  useEditTimesheet = () => {
  const queryClient = useQueryClient()
  const set_error = useSetRecoilState(error_message)
  const set_success = useSetRecoilState(success_message)

  return  useMutation((payload)=>edit_timesheet(payload.payload,payload.id), {
      onSuccess: data => {
        set_success('Successfully edited timesheet!')
        setTimeout(() => {
          set_success('')
        }, 4000);
        queryClient.invalidateQueries('get_timesheets')
      },
      onError: () => {
        set_error('Problem Creating timesheet!')
        setTimeout(() => {
          set_error('')
        }, 4000);
      }
  })
}

export default useEditTimesheet;